import React from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
import { Link } from 'react-router-dom';
export function EvaSchiffererMentaleGesundheitPage() {
  return <div className="min-h-screen bg-white" data-id="element-1477">
      <Header data-id="element-1478" />
      {/* Hero Section mit Bild und Überschrift */}
      <section className="w-full mt-[152px] flex justify-center" data-id="element-1479">
        <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-1480">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wV2eRedDuwJyjyT6dqjRMP/Header-mentale_Gesundheit-Eva_Schifferer.jpg" alt="Mentale Gesundheit Header Bild" className="w-full h-full object-cover" data-id="element-1481" />
          <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-1482"></div>
          <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-1483">
            <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-1484">
              <div className="max-w-lg text-left" data-id="element-1485">
                <p className="text-white text-2xl md:text-3xl font-light mb-4" data-id="element-1486">
                  Nur wer mental gesund ist, kann sein Potenzial voll
                  ausschöpfen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="w-full py-16 px-6 md:px-12" data-id="element-1487">
        <div className="max-w-4xl mx-auto" data-id="element-1488">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1489">
            Mentale Gesundheit
          </h1>
          <div className="prose prose-lg max-w-none" data-id="element-1490">
            <p className="text-lg text-gray-700 mb-8" data-id="element-1491">
              Mentale Gesundheit als Erfolgsfaktor – für Menschen und
              Organisationen
            </p>
            <p className="text-lg text-gray-700 mb-8" data-id="element-1492">
              Wer dauerhaft viel leisten will, braucht mentale Stärke – und ein
              Arbeitsumfeld, das sie schützt. Denn mentale Gesundheit ist eine
              der Grundvoraussetzungen für Leistungsfähigkeit und
              Spitzenleistung.
            </p>
            <p className="text-lg text-gray-700 mb-8" data-id="element-1493">
              In der Realität sieht das häufig anders aus: Hohe Erwartungen,
              wenig Raum für persönliche Themen, viele unausgesprochene
              Spannungen im Team. Zwischen den Zeilen lautet die Botschaft oft:
              Hauptsache die Zahlen und der Umsatz stimmen.
            </p>
            <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-1494">
              <div className="w-full md:w-1/2" data-id="element-1495">
                <p className="text-lg text-gray-700" data-id="element-1496">
                  Doch was wäre, wenn wir ungenutzte individuelle Potenziale und
                  Ressourcen, die ein Team leistungsfähig halten erschließen –
                  und Sie, ihr Team oder ihre Organisation resilienter und
                  zukunftsfähiger machen?
                </p>
              </div>
              <div className="w-full md:w-1/2" data-id="element-1497">
                <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full" data-id="element-1498">
                  <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1499">
                    „Du kannst nicht für andere da sein, wenn du dich selbst
                    verlierst."
                  </blockquote>
                  <p className="text-right text-gray-600" data-id="element-1500">– Brené Brown</p>
                </div>
              </div>
            </div>
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1501">
              Mentale Gesundheit ist kein Soft Skill – sondern ein echter
              Wettbewerbsvorteil
            </h2>
            <p className="text-lg text-gray-700 mb-12" data-id="element-1502">
              Gesunde, psychisch stabile Mitarbeitende treffen bessere
              Entscheidungen, kommunizieren klarer, sind belastbarer – und
              tragen aktiv zu einer positiven, leistungsfähigen
              Unternehmenskultur bei.
            </p>
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1503">
              Mein Angebot:
            </h2>
            <div className="bg-blue-50 p-8 rounded-lg mb-12" data-id="element-1504">
              <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1505">
                Impulsvorträge & Keynotes
              </h3>
              <p className="text-lg text-gray-700 mb-4" data-id="element-1506">
                Kompakt, fundiert und wirkungsvoll: In meinen Vorträgen
                vermittle ich psychologisches Know-how praxisnah und auf den
                Punkt – zu Themen wie:
              </p>
              <ul className="space-y-4 text-gray-700 mb-6" data-id="element-1507">
                <li className="flex items-start" data-id="element-1508">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1509"></div>
                  <span data-id="element-1510">Mentale Gesundheit am Arbeitsplatz</span>
                </li>
                <li className="flex items-start" data-id="element-1511">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1512"></div>
                  <span data-id="element-1513">Gesunde Führung</span>
                </li>
                <li className="flex items-start" data-id="element-1514">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1515"></div>
                  <span data-id="element-1516">Mentale Stärke & Selbstfürsorge</span>
                </li>
              </ul>
              <p className="text-lg text-gray-700" data-id="element-1517">
                Ideal für Teamtage, Führungskräfteveranstaltungen oder interne
                Lernformate.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg mb-12" data-id="element-1518">
              <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1519">
                Workshops & Trainings
              </h3>
              <p className="text-lg text-gray-700 mb-4" data-id="element-1520">
                Ich unterstütze Teams und Organisationen mit praxisnahen
                Workshops und Trainings zu folgenden Themen:
              </p>
              <ul className="space-y-4 text-gray-700" data-id="element-1521">
                <li className="flex items-start" data-id="element-1522">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1523"></div>
                  <span data-id="element-1524">Resilienz und Stressmanagement</span>
                </li>
                <li className="flex items-start" data-id="element-1525">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1526"></div>
                  <span data-id="element-1527">Mentale Gesundheit im Arbeitsalltag</span>
                </li>
                <li className="flex items-start" data-id="element-1528">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1529"></div>
                  <span data-id="element-1530">Gesunde Führung</span>
                </li>
                <li className="flex items-start" data-id="element-1531">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1532"></div>
                  <span data-id="element-1533">Konstruktive Kommunikation und Konfliktklärung</span>
                </li>
              </ul>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg mb-12" data-id="element-1534">
              <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1535">
                Krisenbegleitung und Prävention
              </h3>
              <p className="text-lg text-gray-700 mb-4" data-id="element-1536">
                Psychische Belastungen gehören zum Berufsalltag – doch oft
                werden sie zu spät erkannt, tabuisiert und nicht ernst genommen.
                Dabei ist es möglich, erste Warnzeichen früh wahrzunehmen,
                Dynamiken besser zu verstehen und gezielt gegenzusteuern.
              </p>
              <p className="text-lg text-gray-700 mb-4" data-id="element-1537">
                Ich unterstütze Unternehmen, Führungskräfte und Mitarbeitende
                dabei:
              </p>
              <ul className="space-y-4 text-gray-700" data-id="element-1538">
                <li className="flex items-start" data-id="element-1539">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1540"></div>
                  <span data-id="element-1541">psychische Belastung am Arbeitsplatz zu erkennen.</span>
                </li>
                <li className="flex items-start" data-id="element-1542">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1543"></div>
                  <span data-id="element-1544">offen und lösungsorientiert damit umzugehen.</span>
                </li>
                <li className="flex items-start" data-id="element-1545">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1546"></div>
                  <span data-id="element-1547">
                    präventive Maßnahmen zu entwickeln, die Gesundheit,
                    Stabilität und Leistungsfähigkeit erhalten.
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1548">
              <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1549">
                Kontakt
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-1550">
                Ob Sie als Führungskraft neue Impulse suchen, eine Krise
                bewältigen möchten oder Mental Health strategisch in Ihrer
                Organisation verankern wollen – ich unterstütze Sie mit
                psychologischer Expertise, wirtschaftlicher Erfahrung und klarem
                Blick für das Machbare.
              </p>
              <p className="text-lg text-gray-700 mb-4 font-medium" data-id="element-1551">
                Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
              </p>
              <Link to="/eva_schifferer/termin-vereinbaren" data-id="element-1552">
                <button className="py-3 px-6 bg-blue-100 text-gray-700 rounded-md hover:bg-[#c2cde0] hover:font-semibold transition-colors" data-id="element-1553">
                  Termin vereinbaren
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <EvaSchiffererFooter data-id="element-1554" />
    </div>;
}